<template>
  <div>
    <el-dialog v-el-drag-dialog :close-on-click-modal="false" :visible.sync="innerVisible" :title="$t('CargoMsg.Cargo_ChooseFee')" :show-close="false" @close="cancel">

      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        :style="{width:'100%',height:'300px'}"
      />
      <div slot="footer">
        <el-button type="primary" no="1" size="mini" @click="successEvent">{{ $t('Billing.billingView_Determine') }}</el-button>
        <el-button size="mini" no="2" @click="cancel">{{ $t('Billing.billingView_Close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getGridSelected } from '@/utils/agGrid'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import { cache } from '@/utils/cacheManager'

export default {
  name: 'ChargeSplitByJobDialog',
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    exceptKeys: { type: Array, required: true }, // 弹框打开时默认传递条件
    viewSource: { type: String, required: true } // 请求来源
  },
  data() {
    return {
      innerVisible: this.visible,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: this.exceptKeys ? this.exceptKeys : [],
      hmToFinanceApi: false
    }
  },
  computed: {},
  created() {
    this.columnDefs = [
      {
        headerName: '', width: 60, checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      { headerName: this.$t('Billing.billingJob_businessNumber'), field: 'jobJobNo', width: 200 },
      { headerName: this.$t('Billing.billingCharge_chargeItem'), field: 'chargeItemId', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
        } },
      { headerName: this.$t('Billing.billingCharge_paymentType'), field: 'chargeReceivable', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.chargeReceivableLabelFun(params.value)
        } },
      { headerName: this.$t('Billing.billingCharge_currency'), field: 'chargeCurrency', width: 110 },
      { headerName: this.$t('Billing.billingForm_unit'), field: 'chargeMeasure', width: 110 },
      { headerName: this.$t('Billing.billingCharge_amount'), field: 'chargeQuantity', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2)
        } },
      { headerName: this.$t('Billing.billingCharge_unitPrice'), field: 'chargeUnitRate', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2)
        } },
      { headerName: this.$t('Billing.billingCharge_taxIncludedPrice'), field: 'chargeAmount', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2)
        } },
      { headerName: this.$t('Billing.billingCharge_taxExcludedPrice'), field: 'chargeExcludingTaxAmount', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2)
        } },
      { headerName: this.$t('Billing.billingJob_taxRate'), field: 'chargeTaxRate', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2)
        } },
      { headerName: this.$t('Billing.billingCharge_taxAmount'), field: 'chargeTaxAmount', width: 150,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2)
        } },
      { headerName: this.$t('Billing.billingCharge_remarks'), field: 'chargeRemarks', width: 150 }
    ]
    this.hmToFinanceApi = cache.hqConfig.get('ToFinanceApi') === 'HM' // 上海虹迈
  },
  beforeMount() {
  },
  methods: {
    cancel() {
      const viewSource = this.viewSource
      if (viewSource === 'billingDetail') {
        this.$emit('chargeSplitByJobCallBackEvent', null)
      }
    },
    successEvent() {
      const viewSource = this.viewSource
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpense'))
        return
      }
      if (chooseRows.length !== 1) {
        this.$message.warning(this.$t('CargoMsg.OnlySelectOneChargeToSplit'))
        return
      }
      const charge = chooseRows[0]
      if (charge['chargeInvoiceAmount'] && Number(charge['chargeInvoiceAmount']) > 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ThisFeeHasBeenInvoiced'))
        return
      }
      if (charge['chargeVerifiedAmount'] && Number(charge['chargeVerifiedAmount']) > 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ThisFeeHasBeenWrittenOff'))
        return
      }
      if (this.hmToFinanceApi) {
        if (charge.chargeSyncExternalStatus === ChargeConstants.HM_YONGYOU_SYNC_SUCCESS.code) {
          this.$message.warning(this.$t('Clearing.SyncChargeNotSplit'))
          return
        }
      }
      if (viewSource === 'billingDetail') {
        this.$emit('chargeSplitByJobCallBackEvent', charge)
      }
    }
  }
}
</script>
